/**
 * VideoLinks PDP pincode ETA
 * Origin warehouse: Domlur, Bengaluru 560071
 * Tentative ranges by city tier + product readiness.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'vl_pincode_eta';
  var ORIGIN_PIN = '560071';
  var CUTOFF_HOUR_IST = 17;

  // HRA X metros (Tier 1) — normalized name needles
  var TIER1 = [
    'ahmedabad',
    'bengaluru',
    'bangalore',
    'chennai',
    'delhi',
    'new delhi',
    'hyderabad',
    'kolkata',
    'mumbai',
    'pune',
    'gurugram',
    'gurgaon',
    'noida',
    'ghaziabad',
    'faridabad'
  ];

  // Subset of HRA Y (Tier 2) cities — enough for common destinations
  var TIER2 = [
    'agra',
    'ajmer',
    'amravati',
    'amritsar',
    'aurangabad',
    'bareilly',
    'belagavi',
    'belgaum',
    'bhavnagar',
    'bhopal',
    'bhubaneswar',
    'bikaner',
    'chandigarh',
    'coimbatore',
    'cuttack',
    'dehradun',
    'dhanbad',
    'erode',
    'gorakhpur',
    'guntur',
    'guwahati',
    'gwalior',
    'hubballi',
    'hubli',
    'indore',
    'jabalpur',
    'jaipur',
    'jalandhar',
    'jammu',
    'jamnagar',
    'jamshedpur',
    'jodhpur',
    'kanpur',
    'kochi',
    'ernakulam',
    'kolhapur',
    'kota',
    'kozhikode',
    'calicut',
    'lucknow',
    'ludhiana',
    'madurai',
    'mangaluru',
    'mangalore',
    'meerut',
    'mysuru',
    'mysore',
    'nagpur',
    'nashik',
    'nellore',
    'patna',
    'prayagraj',
    'allahabad',
    'puducherry',
    'pondicherry',
    'raipur',
    'rajkot',
    'ranchi',
    'salem',
    'solapur',
    'srinagar',
    'surat',
    'thiruvananthapuram',
    'trivandrum',
    'thrissur',
    'tiruchirappalli',
    'trichy',
    'tirunelveli',
    'vadodara',
    'varanasi',
    'vijayawada',
    'visakhapatnam',
    'warangal',
    'noida',
    'mohali',
    'pimpri',
    'thane',
    'navi mumbai',
    'howrah',
    'siliguri',
    'asansol',
    'durgapur',
    'uttara kannada',
    'udaipur',
    'aligarh',
    'moradabad',
    'jhansi',
    'mathura',
    'karnal',
    'rohtak',
    'hisar',
    'panaji',
    'goa',
    'shimla',
    'imphal',
    'shillong',
    'agartala',
    'aizawl',
    'kohima',
    'itanagar',
    'gangtok'
  ];

  var SPECIAL_STATES = [
    'jammu & kashmir',
    'jammu and kashmir',
    'ladakh',
    'assam',
    'meghalaya',
    'manipur',
    'mizoram',
    'nagaland',
    'tripura',
    'arunachal pradesh',
    'sikkim',
    'andaman & nicobar islands',
    'andaman and nicobar islands',
    'lakshadweep'
  ];

  // PIN prefix (first 3 digits) → tier fallback when API unavailable
  var PREFIX_TIER1 = {
    110: 1, 121: 1, 122: 1, 201: 1,
    380: 1, 381: 1, 382: 1,
    400: 1, 401: 1,
    411: 1, 412: 1,
    500: 1, 501: 1, 502: 1,
    560: 1, 561: 1, 562: 1,
    600: 1, 601: 1, 602: 1, 603: 1,
    700: 1, 701: 1
  };

  var PREFIX_TIER2 = {
    132: 2, 133: 2, 134: 2, 140: 2, 141: 2, 143: 2, 144: 2, 160: 2, 180: 2, 190: 2,
    208: 2, 221: 2, 226: 2, 248: 2, 250: 2, 273: 2, 282: 2,
    302: 2, 313: 2, 324: 2, 342: 2, 360: 2, 361: 2, 364: 2, 390: 2, 395: 2,
    403: 2, 422: 2, 440: 2, 441: 2, 462: 2, 482: 2, 452: 2,
    492: 2, 520: 2, 530: 2, 533: 2, 570: 2, 575: 2, 580: 2, 590: 2,
    605: 2, 620: 2, 625: 2, 641: 2, 682: 2, 695: 2, 673: 2, 680: 2,
    751: 2, 753: 2, 800: 2, 804: 2, 826: 2, 831: 2, 834: 2,
    781: 2
  };

  var SPECIAL_PREFIX = {
    180: true, 181: true, 182: true, 184: true, 185: true, 190: true, 191: true, 192: true, 193: true, 194: true,
    744: true,
    781: true, 782: true, 783: true, 784: true, 785: true, 786: true, 787: true, 788: true, 789: true,
    790: true, 791: true, 792: true, 793: true, 794: true, 795: true, 796: true, 797: true, 798: true, 799: true
  };

  // Transit day ranges [min, max] after the order is ready to ship
  var TRANSIT = {
    local: [1, 2],
    tier1: [2, 4],
    tier2: [3, 5],
    tier3: [4, 7],
    special: [7, 12]
  };

  var PROCESSING = {
    normal: [0, 1],
    supplierDefault: [3, 4]
  };

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function normalize(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9&\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function includesAny(hay, list) {
    for (var i = 0; i < list.length; i++) {
      if (hay.indexOf(list[i]) !== -1) return true;
    }
    return false;
  }

  function isValidPin(pin) {
    return /^[1-9][0-9]{5}$/.test(pin);
  }

  function istParts(date) {
    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      weekday: 'short',
      hour12: false
    });
    var parts = {};
    fmt.formatToParts(date).forEach(function (p) {
      if (p.type !== 'literal') parts[p.type] = p.value;
    });
    return parts;
  }

  function addCalendarDays(date, days) {
    var d = new Date(date.getTime());
    d.setUTCDate(d.getUTCDate() + days);
    return d;
  }

  function skipSundaysForward(date, businessDays) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < businessDays) {
      d = addCalendarDays(d, 1);
      var wd = istParts(d).weekday;
      if (wd !== 'Sun') added += 1;
    }
    return d;
  }

  function formatDay(date) {
    var p = istParts(date);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var m = months[parseInt(p.month, 10) - 1];
    return m + ' ' + parseInt(p.day, 10);
  }

  function parseSupplierDays(text) {
    if (!text) return PROCESSING.supplierDefault.slice();
    var nums = String(text).match(/\d+/g);
    if (!nums || !nums.length) return PROCESSING.supplierDefault.slice();
    if (nums.length === 1) {
      var n = parseInt(nums[0], 10);
      return [n, n];
    }
    return [parseInt(nums[0], 10), parseInt(nums[1], 10)];
  }

  function classifyByNames(district, state, city) {
    var hay = normalize([city, district, state].join(' '));
    var stateN = normalize(state);

    if (SPECIAL_STATES.indexOf(stateN) !== -1 || includesAny(hay, ['andaman', 'lakshadweep', 'ladakh'])) {
      return 'special';
    }

    // Local Bengaluru / Domlur catchment
    if (includesAny(hay, ['bengaluru', 'bangalore', 'domlur'])) {
      return 'local';
    }

    if (includesAny(hay, TIER1)) return 'tier1';
    if (includesAny(hay, TIER2)) return 'tier2';
    return 'tier3';
  }

  function classifyByPrefix(pin) {
    var pref = parseInt(pin.slice(0, 3), 10);
    if (pref >= 560 && pref <= 562) return 'local';
    if (SPECIAL_PREFIX[pref]) return 'special';
    if (PREFIX_TIER1[pref]) return 'tier1';
    if (PREFIX_TIER2[pref]) return 'tier2';
    return 'tier3';
  }

  function tierLabel(zone) {
    switch (zone) {
      case 'local':
        return 'local';
      case 'tier1':
        return 'Tier 1';
      case 'tier2':
        return 'Tier 2';
      case 'tier3':
        return 'Tier 3';
      case 'special':
        return 'remote';
      default:
        return '';
    }
  }

  function readinessDays(root) {
    var mode = root.getAttribute('data-stock-mode') || 'normal';
    if (mode === 'coming_soon') return null;
    if (mode === 'out_of_stock') return null;
    if (mode === 'supplier') {
      return parseSupplierDays(root.getAttribute('data-supplier-shipping'));
    }
    if (mode === 'preorder') {
      var pre = root.getAttribute('data-preorder-days');
      if (pre) return parseSupplierDays(pre);
      return [5, 10];
    }
    return PROCESSING.normal.slice();
  }

  function processingOffsetNow() {
    var now = new Date();
    var p = istParts(now);
    var hour = parseInt(p.hour, 10);
    // After cutoff → start from next business day
    var start = now;
    if (hour >= CUTOFF_HOUR_IST || p.weekday === 'Sun') {
      start = skipSundaysForward(now, 1);
    }
    return start;
  }

  function computeRange(zone, readyMin, readyMax) {
    var transit = TRANSIT[zone] || TRANSIT.tier3;
    var startBase = processingOffsetNow();
    var from = skipSundaysForward(startBase, readyMin + transit[0]);
    var to = skipSundaysForward(startBase, readyMax + transit[1]);
    // Ensure to >= from
    if (to.getTime() < from.getTime()) to = from;
    return { from: from, to: to };
  }

  function lookupPin(pin) {
    return fetch('https://api.postalpincode.in/pincode/' + pin, {
      method: 'GET',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var row = Array.isArray(data) ? data[0] : null;
        if (!row || row.Status !== 'Success' || !row.PostOffice || !row.PostOffice.length) {
          return null;
        }
        var po = row.PostOffice[0];
        return {
          city: po.Name || '',
          district: po.District || '',
          state: po.State || '',
          block: po.Block || ''
        };
      })
      .catch(function () {
        return null;
      });
  }

  function placeLabel(info) {
    if (!info) return '';
    var district = info.district || '';
    var state = info.state || '';
    if (district && state && normalize(district) !== normalize(state)) {
      return district;
    }
    return district || state || '';
  }

  function setResult(root, tone, html, hint) {
    var el = qs(root, '[data-eta-result]');
    var hintEl = qs(root, '[data-eta-hint]');
    if (!el) return;
    el.setAttribute('data-tone', tone || '');
    el.innerHTML = html || '';
    if (hintEl) {
      hintEl.textContent = hint || '';
      hintEl.hidden = !hint;
    }
  }

  function savePin(pin) {
    try {
      localStorage.setItem(STORAGE_KEY, pin);
    } catch (e) {}
  }

  function loadPin() {
    try {
      return localStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function resolveMode(baseStock, variant) {
    if (baseStock === 'Coming Soon') return 'coming_soon';
    if (baseStock === 'Supplier Stock') return 'supplier';
    if (!variant) return 'out_of_stock';
    var qty = parseInt(variant.inventory_quantity, 10);
    if (isNaN(qty)) qty = 0;
    if (qty <= 0) {
      if (variant.inventory_policy === 'continue') return 'preorder';
      return variant.available ? 'normal' : 'out_of_stock';
    }
    return 'normal';
  }

  function parseVariants(root) {
    var script = root.querySelector('script[type="application/json"][data-eta-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function currentPin(root) {
    var input = qs(root, '[data-eta-input]');
    var pin = (input && input.value ? input.value : '').trim();
    if (!isValidPin(pin)) pin = loadPin();
    return pin;
  }

  function refreshForMode(root, mode) {
    var prev = root.getAttribute('data-stock-mode');
    root.setAttribute('data-stock-mode', mode);
    var pin = currentPin(root);
    var input = qs(root, '[data-eta-input]');
    if (input && isValidPin(pin) && input.value !== pin) input.value = pin;

    if (mode === 'coming_soon') {
      setResult(root, 'warn', 'Delivery dates will show once this item launches.');
      return;
    }
    if (mode === 'out_of_stock') {
      setResult(root, 'warn', 'Currently unavailable to ship.');
      return;
    }
    if (isValidPin(pin)) {
      // Always recalculate when mode changes (supplier vs in-stock readiness differs)
      if (prev !== mode || qs(root, '[data-eta-result]').textContent) {
        runCheck(root, pin);
      }
    } else if (prev !== mode) {
      setResult(root, '', '');
    }
  }

  function subscribeVariantChanges(root) {
    var productId = root.getAttribute('data-product-id');
    if (!productId) return;
    var baseStock = root.getAttribute('data-base-stock') || '';
    var variants = parseVariants(root);

    function onVariant(variant) {
      var match = null;
      if (variant && variant.id != null) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variant.id)) {
            match = variants[i];
            break;
          }
        }
        if (!match) match = variant;
      }
      refreshForMode(root, resolveMode(baseStock, match));
    }

    function trySubscribe(attempts) {
      if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
        window.MinimogEvents.subscribe(productId + '__VARIANT_CHANGE', onVariant);
        return;
      }
      if (attempts < 40) setTimeout(function () { trySubscribe(attempts + 1); }, 100);
    }
    trySubscribe(0);

    // Backup: watch inventory component status for non-metafield stock products
    if (baseStock !== 'Coming Soon' && baseStock !== 'Supplier Stock') {
      var inv = root.closest('.m-product-inventory-block-container');
      var invEl = inv && inv.querySelector('m-product-inventory');
      if (invEl && window.MutationObserver) {
        var obs = new MutationObserver(function () {
          var status = invEl.getAttribute('data-status') || '';
          var mode = 'normal';
          if (status === 'outofstock') mode = 'out_of_stock';
          else if (status === 'backordered') mode = 'preorder';
          else if (status === 'coming_soon') mode = 'coming_soon';
          if (root.getAttribute('data-stock-mode') !== mode) refreshForMode(root, mode);
        });
        obs.observe(invEl, { attributes: true, attributeFilter: ['data-status'] });
      }
    }
  }

  function setFieldInvalid(root, invalid) {
    var field = qs(root, '.vl-pincode-eta__field');
    var input = qs(root, '[data-eta-input]');
    if (field) field.classList.toggle('is-invalid', !!invalid);
    if (input) input.classList.toggle('is-invalid', !!invalid);
  }

  function runCheck(root, pin) {
    var input = qs(root, '[data-eta-input]');
    var btn = qs(root, '[data-eta-btn]');
    if (!isValidPin(pin)) {
      setFieldInvalid(root, true);
      setResult(root, 'error', 'Enter a valid 6-digit pincode.');
      return;
    }
    setFieldInvalid(root, false);

    var ready = readinessDays(root);
    if (!ready) {
      var mode = root.getAttribute('data-stock-mode');
      if (mode === 'coming_soon') {
        setResult(root, 'warn', 'Delivery dates will show once this item launches.');
      } else {
        setResult(root, 'warn', 'Currently unavailable to ship.');
      }
      return;
    }

    if (btn) btn.disabled = true;
    setResult(root, '', 'Checking…');

    lookupPin(pin).then(function (info) {
      var zone = info
        ? classifyByNames(info.district, info.state, info.city)
        : classifyByPrefix(pin);

      // Same warehouse pincode → local
      if (pin === ORIGIN_PIN || pin.slice(0, 3) === '560') {
        // Keep local for all 560xxx Bengaluru city pins
        if (!info || includesAny(normalize(info.district + ' ' + info.state), ['bengaluru', 'bangalore', 'karnataka'])) {
          if (pin.slice(0, 3) === '560') zone = 'local';
        }
      }

      var range = computeRange(zone, ready[0], ready[1]);
      var place = placeLabel(info);
      var dateText =
        formatDay(range.from) === formatDay(range.to)
          ? formatDay(range.from)
          : formatDay(range.from) + '–' + formatDay(range.to);

      var html = 'Get it by <strong>' + dateText + '</strong>';
      if (place) html += ' · ' + place;

      setResult(root, '', html);
      savePin(pin);
    }).finally(function () {
      if (btn) btn.disabled = false;
    });
  }

  function bind(root) {
    if (root.dataset.vlBound === '1') return;
    root.dataset.vlBound = '1';

    var mode = root.getAttribute('data-stock-mode') || 'normal';
    var input = qs(root, '[data-eta-input]');
    var btn = qs(root, '[data-eta-btn]');
    var form = qs(root, '[data-eta-form]');

    var saved = loadPin();
    if (input && saved && isValidPin(saved)) {
      input.value = saved;
    }

    function submit(e) {
      if (e) e.preventDefault();
      var pin = (input && input.value ? input.value : '').trim();
      runCheck(root, pin);
    }

    if (form) form.addEventListener('submit', submit);
    if (btn) btn.addEventListener('click', submit);
    if (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
        setFieldInvalid(root, false);
      });
    }

    subscribeVariantChanges(root);

    if (saved && isValidPin(saved) && mode !== 'coming_soon' && mode !== 'out_of_stock') {
      runCheck(root, saved);
    } else if (mode === 'coming_soon') {
      setResult(root, 'warn', 'Delivery dates will show once this item launches.');
    } else if (mode === 'out_of_stock') {
      setResult(root, 'warn', 'Currently unavailable to ship.');
    }
  }

  function init() {
    document.querySelectorAll('[data-vl-pincode-eta]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
